import { useEffect } from "react";
import Grain from "@/components/wam/Grain";
import Cursor from "@/components/wam/Cursor";
import ReplayNav from "@/components/replay/ReplayNav";
import ReplayHero from "@/components/replay/ReplayHero";
import ReplayTicker from "@/components/replay/ReplayTicker";
import ReplayManifesto from "@/components/replay/ReplayManifesto";
import ReplayOperatingSystem from "@/components/replay/ReplayOperatingSystem";
import ReplayWhy from "@/components/replay/ReplayWhy";
import ReplayProcess from "@/components/replay/ReplayProcess";
import ReplayTestimonials from "@/components/replay/ReplayTestimonials";
import ReplayFaq from "@/components/replay/ReplayFaq";
import ReplayBooking from "@/components/replay/ReplayBooking";
import ReplayFooter from "@/components/replay/ReplayFooter";
import StickyMobileBookCta from "@/components/replay/StickyMobileBookCta";
import { captureAttribution } from "@/lib/utm";
import { REPLAY_CONFIG } from "@/config/replay";

export default function Replay() {
  // Capture UTM/attribution on landing
  useEffect(() => {
    captureAttribution();
  }, []);

  // Set page title + meta description dynamically
  useEffect(() => {
    const cfg = REPLAY_CONFIG;
    if (cfg.WEBINAR_TITLE) {
      document.title = `${cfg.WEBINAR_TITLE} | Small Business Automator`;
    } else {
      document.title = "Webinar Replay | Small Business Automator";
    }
    const desc = cfg.META_DESCRIPTION || cfg.WEBINAR_PROMISE;
    if (desc) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", desc);

      // Open Graph
      const upsert = (property, content) => {
        let el = document.querySelector(`meta[property="${property}"]`);
        if (!el) {
          el = document.createElement("meta");
          el.setAttribute("property", property);
          document.head.appendChild(el);
        }
        el.setAttribute("content", content);
      };
      upsert(
        "og:title",
        `${cfg.WEBINAR_TITLE || "Webinar Replay"} | Small Business Automator`
      );
      upsert("og:description", desc);
      upsert("og:type", "website");
    }
  }, []);

  return (
    <div id="top" className="relative bg-[#070709] text-[#F0ECE4] min-h-screen overflow-x-hidden">
      <Grain />
      <Cursor />
      <ReplayNav />
      <main>
        <ReplayHero />
        <ReplayTicker />
        <ReplayManifesto />
        <ReplayOperatingSystem />
        <ReplayWhy />
        <ReplayProcess />
        <ReplayTestimonials />
        <ReplayFaq />
        <ReplayBooking />
      </main>
      <ReplayFooter />
      <StickyMobileBookCta />
    </div>
  );
}
